import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42hXJSw6AIAwFQO5/G4yWNkH7kaQLVuzfYZTlZAqzLBZBY0atB86LQNR+C3q/Z4mIlZl4x4Cq4VHdATOHe8wPOs4w0PASavIAAAAASUVORK5CYII="};
